import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from './utils/api';
import './styles/common.css';
import './styles/index.css';

import './styles/gameEntrance.css';
import Draggable from 'react-draggable';

function Carousel() {
    const [campaigns, setCampaigns] = useState([]);
    const [activeCampaignIndex, setActiveCampaignIndex] = useState(0);
    const intervalRef = useRef();
    useEffect(() => {
        api.getCampaigns().then((json) => {
            setCampaigns(json.data);
            intervalRef.current = window.setInterval(() => {
                setActiveCampaignIndex((prev) => (prev === json.data.length - 1 ? 0 : prev + 1));
            }, 5000);
        });
    }, []);
    return (
        <div className="carousel">
            {campaigns.map((campaign, index) => (
                <Link
                    className={`carousel__campaign${index === activeCampaignIndex ? ' carousel__campaign--active' : ''}`}
                    style={{
                        backgroundImage: `url(${campaign.picture})`,
                    }}
                    key={campaign.id}
                    to={`./product?id=${campaign.product_id}`}
                >
                    <div className="carousel__campaign-story">
                        <div className="carousel__campaign-story-content">{campaign.story.split('\r\n').slice(0, 3).join('\r\n')}</div>
                        <div className="carousel__campaign-story-title">{campaign.story.split('\r\n')[3]}</div>
                    </div>
                </Link>
            ))}
            <div className="carousel__dots">
                {campaigns.map((campaign, index) => (
                    <div
                        className={`carousel__dot${index === activeCampaignIndex ? ' carousel__dot--active' : ''}`}
                        key={campaign.id}
                        onClick={() => {
                            setActiveCampaignIndex(index);
                            window.clearInterval(intervalRef.current);
                            intervalRef.current = window.setInterval(() => {
                                setActiveCampaignIndex((prev) => (prev === campaigns.length - 1 ? 0 : prev + 1));
                            }, 5000);
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

function Products() {
    const [products, setProducts] = useState([]);
    const [params] = useSearchParams();
    useEffect(() => {
        let nextPagingRef = 0;
        setProducts([]);
        const intersectionObserver = new IntersectionObserver(async ([entry], observer) => {
            const { intersectionRatio, target } = entry;
            if (intersectionRatio <= 0) return;

            const q = params.get('q');
            const category = params.get('category');

            function fetchProducts() {
                if (q) {
                    return api.searchProducts(q, nextPagingRef);
                }
                if (category) {
                    return api.getProducts(category, nextPagingRef);
                }
                return api.getProducts('all', nextPagingRef);
            }

            await fetchProducts().then((json) => {
                setProducts((prev) => [...prev, ...json.data]);
                nextPagingRef = json.next_paging;
            });
            if (nextPagingRef === undefined) {
                observer.unobserve(target);
                return;
            }
        });
        const waypoint = document.querySelector('.waypoint');
        intersectionObserver.observe(waypoint);
        return () => intersectionObserver.unobserve(waypoint);
    }, [params]);
    return (
        <React.Fragment>
            <div className="products">
                <GameEntrance />
                {products.map((product) => (
                    <Link className="product-index" key={product.id} to={`./product?id=${product.id}`}>
                        <img src={product.main_image} className="product__image" alt="product" />
                        <div className={product.on_sale === 0 ? 'no__sale' : 'on__sale__main'}>SALE</div>
                        <div className="product__colors">
                            {product.colors.slice(0, 4).map((color) => (
                                <div
                                    className="product__color"
                                    style={{
                                        backgroundColor: `#${color.code}`,
                                    }}
                                    key={color.code}
                                />
                            ))}
                        </div>
                        <div className="product__title">{product.title}</div>
                        <div className="product-index__price">TWD.{product.price}</div>
                    </Link>
                ))}
            </div>
            <div className="waypoint" style={{ height: '100px' }}></div>
        </React.Fragment>
    );
}

function GameEntrance() {
    const [isDragging,setIsDragging] = useState(false);
    const aws_JWT = window.localStorage.getItem('aws_JWT');
    
    return (
        <Link to={'./game'} className={isDragging === true ? 'disabled-link' : ''}>
            <Draggable
                axis="both"
                defaultPosition={{ x: 0, y: 0 }}
                scale={1}
                onClick={() => {console.log("click")}}
                onDrag={() => {setIsDragging(true)}}
                onStop={() => {setIsDragging(false)}}
                // onMouseDown={(e) => console.log('預計跳轉至轉盤遊戲頁面')}
            >
                <div className="game-entrance"></div>
            </Draggable>
        </Link>
    );
}

export default function Home() {
    const keyDownText = useRef('');

    useEffect(() => {
        function handleKeyDown(e) {
            keyDownText.current = keyDownText.current + e.code.replace('Key', '').replace('Space', ' ');
            console.log(`目前打字紀錄：${keyDownText.current}`);

            if (keyDownText.current === 'THISISUNSAFE') {
                alert('秘密通道已被開啟');
                document.querySelector('.game-entrance').style.animationName = 'earthquake';
            }
        }
        document.addEventListener('keypress', handleKeyDown);
    }, []);

    return (
        <>
            <Carousel />
            <Products />
        </>
    );
}
